import { getPlanReferenceData } from './plansReference';

const getErrorId = (errorData) => Object.keys(errorData).some((key) => key === 'id');

export const ErrorMessage = (errorLists, pageName) => {
  let errorMessageLabel;
  let redirectPage = false;
  let errorId = errorLists && errorLists[0].id;
  let errorData = errorLists && errorLists[0];
  const ROUTE_TO_PAGE_DATA = getPlanReferenceData() && getPlanReferenceData().ROUTE_TO_PAGE;
  const ERROR_MESSAGES_LISTS = (getPlanReferenceData() && getPlanReferenceData().USER_FRIENDLY_ERROR_MESSAGES) || {
    '0000': 'Looks like something went wrong. Please try again later.',
  };
  const getMessageTitle = (errors) => {
    if (getErrorId(errors) && Object.keys(ROUTE_TO_PAGE_DATA || {}).includes(errors.id)) {
      errorMessageLabel = ROUTE_TO_PAGE_DATA[errors.id];
      redirectPage = true;
      errorId = errors.id;
      errorData = errors;
    } else {
      const pageErrorList = ERROR_MESSAGES_LISTS[pageName];
      errorMessageLabel = getErrorId(errors) ? pageErrorList && pageErrorList[errors.id] : '';
      errorMessageLabel = getErrorId(errors) && !errorMessageLabel ? ERROR_MESSAGES_LISTS[errors.id] : errorMessageLabel;
      errorId = errors.id;
      errorData = errors;
    }
  };
  if (errorLists.length > 1) {
    errorLists.map((list) => (errorMessageLabel === undefined || errorMessageLabel === '') && getMessageTitle(list));
  } else {
    getMessageTitle(errorLists[0]);
  }
  if (errorMessageLabel && errorMessageLabel.length > 0) {
    return {
      message: errorMessageLabel,
      id: errorId,
      noteMessage: `errorIdPresent: ${errorId}`,
      redirect: redirectPage,
    };
  }
  if (getErrorId(errorData)) {
    return {
      message: ERROR_MESSAGES_LISTS['0000'],
      id: errorId,
      noteMessage: `errorMessageNotAvailable: ${errorId}`,
      redirect: redirectPage,
    };
  }
  return { message: ERROR_MESSAGES_LISTS['0000'], noteMessage: `errorIdNotPresent`, redirect: redirectPage };
};
